/**
 * this file contains all redux-saga watchers & workers for the aministrator funds summary
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 19/06/18
 */

import { takeEvery, call, put } from "redux-saga/effects";

import C from "../constants";
import config from "../config";
import { request, isEmpty, substitute } from "../utility/utilities";

// import action creators
import * as FundsSummaryActions from "../actions/fundsSummaryActions";

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE CLASS RESPONSE
----------------------------------------------------------------------------- */

// watcher saga for fetching the funds summary data
export function* watchFetchFundsSummary() {
    yield takeEvery(C.FETCH_FUNDS_SUMMARY_DATA, workerFetchFundsSummary);
}

// worker saga for fetching the funds summary
function* workerFetchFundsSummary() {
    // set the headers
    const headers = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        },
        mode: "cors",
        cache: "default"
    };

    // set the endpoint
    const requestURL = config.endpoints.fundsSummaryFetchURL

    try {
        // get the response promise object
        const response = yield call(request, requestURL, headers);

        if (!isEmpty(response.data)) {

            yield put(
                FundsSummaryActions.setFundsSummaryData(response.data)
            );
        }
    } catch (error) {
        console.log(error)
    }
}

// watcher saga for fetching the funds list data
export function* watchFetchFundsList() {
    yield takeEvery(C.FETCH_FUNDS_LIST_DATA, workerFetchFundsList);
}

// worker saga for fetching the funds list
function* workerFetchFundsList() {
    // set the headers
    const headers = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        },
        mode: "cors",
        cache: "default"
    };

    // set the endpoint
    const requestURL = config.endpoints.fundsListFetchURL

    try {
        // show the loader
        yield put(FundsSummaryActions.showFundsListLoader(true));

        // get the response promise object
        const response = yield call(request, requestURL, headers);

        if (!isEmpty(response.data)) {
            yield put(FundsSummaryActions.setFundsListData(response.data));
        }
    } catch (error) {
        console.log(error)
    } finally {
        // hide the loader regardless
        yield put(FundsSummaryActions.showFundsListLoader(false));
    }
}


// WEBPACK FOOTER //
// ./src/sagas/fundsSummarySaga.js